export class Timeline {

    uuid: string;

    date: any;

    description: string;            // Descrição

    type: string;

    photo: string;

    photoUrl: string;

    public constructor(init?: Partial<Timeline>) {
        Object.assign(this, init);
    }
}
